import {
  SingleBorrowerCreditAuthorization,
  WithCoborrowerCreditAuthorization
} from '../../cards/credit-authorization';
import { Branch, Card } from '../../components/deck';

export const creditAuthorizationBranch = (continuation) =>
  Branch(
    {
      singleBorrower: Card(SingleBorrowerCreditAuthorization),
      withCoborrower: Card(WithCoborrowerCreditAuthorization)
    },
    ({ model }) => (model.getIn(['loan', 'hasCoborrower']) ? 'withCoborrower' : 'singleBorrower'),
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/credit-authorization.js